import VehicleInfo from './vehicle-info'
import PhotoUpload from './photo-upload'
import CustomerDetail from './customer-detail'
import ThanksPage from './thanks-page'
import PhotoGuide from './photo-guide'

export default {
    VehicleInfo,
    PhotoUpload,
    CustomerDetail,
    ThanksPage,
    PhotoGuide,
}